import {
  FormControl,
  MenuItem, Select, TextField as MUITextField,
  Typography
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { useAddress } from "components/request-document/components/Address";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function ExpertiseSection({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);

  const scienceAndtechnologyConfig = get(
    masterData,
    "scienceAndtechnologyConfig",
    []
  );

  const managementConfig = get(masterData, "managementConfig", []);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Please select your area of expertise which will be employed
                during your work assignment in Thailand{" "}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 5 }}>
            <div style={{ width: "50%" }}>
              <div className={classes.wrapField}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Science and technology{" "}
                </InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Science and technology</InputLabel>
                  <Select
                    label="Selected Science and technology"
                    variant="outlined"
                    name={`document.scienceAndtechnologyID`}
                    value={formik.values.document.scienceAndtechnologyID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {scienceAndtechnologyConfig.map((x) => (
                      <MenuItem
                        key={x.scienceAndtechnologyID}
                        value={x.scienceAndtechnologyID}
                      >
                        {x.scienceAndtechnologyName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div style={{ width: "50%", marginLeft: 5 }}>
              <div className={classes.wrapField}>
                <InputLabel>&nbsp;</InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Science and technology</InputLabel>
                  <Select
                    label="Selected Science and technology"
                    variant="outlined"
                    name={`document.scienceAndtechnologySubID`}
                    value={formik.values.document.scienceAndtechnologySubID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {scienceAndtechnologyConfig.map((x) => (
                      <MenuItem
                        key={x.scienceAndtechnologyID}
                        value={x.scienceAndtechnologyID}
                      >
                        {x.scienceAndtechnologyName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 5 }}>
            <div style={{ width: "50%" }}>
              <div className={classes.wrapField}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Management{" "}
                </InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Management</InputLabel>
                  <Select
                    label="Selected Management"
                    variant="outlined"
                    name={`document.managementID`}
                    value={formik.values.document.managementID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {managementConfig.map((x) => (
                      <MenuItem key={x.managementID} value={x.managementID}>
                        {x.managementName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div style={{ width: "50%", marginLeft: 5 }}>
              <div className={classes.wrapField}>
                <InputLabel>&nbsp;</InputLabel>
                <FormControl fullWidth style={{ marginTop: 10 }}>
                  <InputLabel>Selected Management</InputLabel>
                  <Select
                    label="Selected Management"
                    variant="outlined"
                    name={`document.managementSubID`}
                    value={formik.values.document.managementSubID}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {managementConfig.map((x) => (
                      <MenuItem key={x.managementID} value={x.managementID}>
                        {x.managementName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>

          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray", marginTop: 10 }}>
                Details of expertise to be recognized (Please give details
                related to all technologies or expertise selected above)
              </Typography>
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.DetailsOfExpertise"
                value={formik.values.document.DetailsOfExpertise}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.DetailsOfExpertise", formik)}
                helperText={getErrorMessage(
                  "document.DetailsOfExpertise",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ color: "gray" }}>
                Where, when and how this expertise is obtained by the applicant
              </Typography>
            </div>
          </div>
          <TextField
            disabled={!canEdit}
            variant="outlined"
            className={classes.textField}
            name="document.ExpertiseIsObtained"
            value={formik.values.document.ExpertiseIsObtained}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={isError("document.ExpertiseIsObtained", formik)}
            helperText={getErrorMessage("document.ExpertiseIsObtained", formik)}
          />
        </StyledTableCell>
      </TableRow>
    </>
  );
}
